import React, {useMemo} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

import {ERROR_CONTENT, getErrorKind, SystemError} from '@components/SystemError';
import {generateErrorId} from '@utils/errorId';
import {ERROR_RETURN_URL_KEY} from '@utils/systemError';

export type ErrorPageProps = {
    errorCode?: number | string;
    errorId?: string;
};

type LocationErrorState = {
    status?: number | string;
    errorId?: string;
};

export const ErrorPage: React.FC<ErrorPageProps> = ({errorCode, errorId}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const locationState = (location.state || {}) as LocationErrorState;
    const searchCode = searchParams.get('code');
    const searchId = searchParams.get('id');

    const code = errorCode ?? searchCode ?? locationState.status;
    const content = ERROR_CONTENT[getErrorKind(code)];

    const resolvedErrorId = useMemo(
        () => errorId || searchId || locationState.errorId || generateErrorId(),
        [errorId, searchId, locationState.errorId]
    );

    const handleHome = () => {
        navigate('/home');
    };

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
            return;
        }

        handleHome();
    };

    const handleReload = () => {
        const returnUrl = sessionStorage.getItem(ERROR_RETURN_URL_KEY);

        if (returnUrl && returnUrl !== location.pathname + location.search) {
            sessionStorage.removeItem(ERROR_RETURN_URL_KEY);
            window.location.assign(returnUrl);
            return;
        }

        window.location.reload();
    };

    return (
        <SystemError
            imageSrc={content.imageSrc}
            title={content.title}
            description={content.description}
            errorId={resolvedErrorId}
            variant={content.variant}
            onBack={handleBack}
            onReload={handleReload}
            onHome={handleHome}
        />
    );
};
